<template>
    <el-dialog
        class="conferee"
        :visible.sync="confereeVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="参会人员"
    >
        <div class="container">
            <el-table
                border
                :data="tableData"
                ref="tableData"
                highlight-current-row
                height="90%"
                :cell-style="{ fontSize: '12px' }"
                :header-cell-style="{ fontSize: '12px' }"
            >
                <el-table-column label="参会人姓名" property="user_name" align="center"></el-table-column>
                <el-table-column label="部门" property="depart_name" align="center"></el-table-column>
                <el-table-column label="状态" property="status" align="center">
                    <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == '待确认'
                                        ? 'info'
                                        : scope.row.status == '进行中'
                                        ? 'warning'
                                        : scope.row.status == '已接受'
                                        ? 'success'
                                        : scope.row.status == '已取消'
                                        ? 'danger'
                                        : ''
                                "
                            >
                                {{ scope.row.status }}
                            </el-tag>
                        </template>
                </el-table-column>
                <el-table-column label="创建时间" property="create_time" align="center"></el-table-column>
                <!-- <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <div class="color-blue">
                                <div class="color-blue">
                                    <el-button
                                        type="text"
                                        size="small"
                                        @click="detail(scope.row)"
                                        >查看</el-button
                                    >
                                </div>
                            </div>
                        </template>
                    </el-table-column> -->
            </el-table>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange"></pagination>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="confereeVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import pagination from "@/comon/components/pagination";
import { mapState } from "vuex";
export default {
    data() {
        return {
            tableData: [],
            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            tableRow:{}
        };
    },
    props: {
        confereeVisible: Boolean,
        tableItem: Object
    },
    methods: {
        meetingAccept() {
            oaApi
                .meetingAccept({ m_id: this.tableItem.id,...this.paginationData }, "get")
                .then(res => {
                    //console.log(res);
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.meetingAccept();
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:confereeVisible", false);
        },
        detail(row){
            this.tableRow = row;
        }
    },
    watch: {
        confereeVisible: {
            handler(newValue) {
                if (newValue) {
                    this.meetingAccept();
                }
            }
        }
    },
    components: {
        pagination: pagination,
    },
    computed: {}
};
</script>

<style lang="scss" scoped>
.conferee {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
        height: 500px;
    }
}
</style>
